import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SelectionStore} from './selection.store';
import {SelectionHeaderComponent} from './components/selection-header/selection-header.component';
import {SelectionItemsComponent} from './components/selection-items/selection-items.component';
import {SelectionFooterComponent} from './components/selection-footer/selection-footer.component';
import {LoadingService} from '../../shared/services/loading.service';
import {Alert} from '../../shared/components/alert/alert';

@Component({
  selector: 'app-selection',
  imports: [SelectionHeaderComponent, SelectionItemsComponent, SelectionFooterComponent, Alert],
  providers: [SelectionStore],
  templateUrl: './selection.component.html',
  styleUrl: './selection.component.css',
  standalone: true
})
export class SelectionComponent implements OnInit {
  private route = inject(ActivatedRoute);
  readonly selectionStore = inject(SelectionStore);

  private token = '';

  constructor() {
    inject(LoadingService).watch('Loading', () => this.selectionStore.isSnapshotPending() || this.selectionStore.isSubmitPending());
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    this.selectionStore.loadSnapshot(this.token).subscribe();
  }

  submit(signature: string) {
    this.selectionStore.submit(this.token, signature).subscribe();
  }
}
